import { gql } from '@guuru/graphql-common/gql';

export default gql(`#graphql
  mutation UpdatePartnerMembership($partnerId: ID!, $membership: PartnerMembershipInput!) {
    updatePartnerMembership(partnerId: $partnerId, membership: $membership){
      id
    }
  }
`);
